import React from 'react';

import { Navigate } from 'react-router';
import {
    BlankLayout,
    NotFound,
    Forbidden,
    Unauthorized,
    NoPrescriber,
} from '@europrocurement/flexy-components';
import Accueil from '../pages/Accueil/Accueil';

const Router = [
    {
        path: '/',
        element: <BlankLayout />,
        children: [
            { path: '/', element: <Navigate to="/accueil" /> },
            {
                path: 'accueil',
                exact: true,
                element: <Accueil />,
            },
        ],
    },
    {
        path: '/errors',
        element: <BlankLayout />,
        children: [
            { path: '404', element: <NotFound /> },
            { path: '403', element: <Forbidden /> },
            { path: '401', element: <Unauthorized /> },
            {
                path: 'noPrescriber',
                element: <NoPrescriber />,
            },
        ],
    },
    {
        path: '*',
        element: <NotFound />,
    },
];

export default Router;
